export var ConsentCategory;
(function (ConsentCategory) {
    ConsentCategory["SocialMedia"] = "socialmedia";
    ConsentCategory["TargetedAdvertising"] = "targetedadvertising";
    ConsentCategory["ContentRecommendation"] = "contentrecommendation";
    ConsentCategory["Functional"] = "functional";
    ConsentCategory["Marketing"] = "marketing";
})(ConsentCategory || (ConsentCategory = {}));
